import React from "react"
import { useSiteContext } from "../common/SiteContext"
import { graphql, useStaticQuery } from "gatsby"
import { Testimonials } from "@organic-return/foundation-react/src/components/Blades/Testimonials"
import { ITestimonial } from "@organic-return/foundation-react/src/lib"
import { Button } from "@organic-return/foundation-react/src/components/Button"

export const TestimonialSlider = ({ module }) => {
    const data = useStaticQuery(graphql`
      query {  
        allTestimonial {
          nodes {
            text
            attribution
          }
        }
      }
    `)
    const siteContext = useSiteContext()
    const fields = module.customFields

    let testimonials: ITestimonial[] = data.allTestimonial?.nodes?.map((t): ITestimonial => {
        return {
            text: t.text,
            attribution: t.attribution
        }
    })

    if (fields.maxTestimonials && testimonials.length > fields.maxTestimonials) {
        testimonials = testimonials.slice(0, fields.maxTestimonials)
    }

    return (
        <div className="testimonial-slider w-full px-2 py-14">
            <Testimonials
                title={fields.title}
                testimonials={testimonials}
                leftColumn={(<></>)}
                showAttribution={true}
                {...siteContext.globalTestimonialSliderProps}
            />
            {fields.callToAction &&
                <div className="w-full flex justify-center">
                    <Button
                        linkProps={{
                            href: fields.callToAction.href,
                            target: fields.callToAction.target,
                        }}
                    >
                        {fields.callToAction.text}
                    </Button>
                </div>
            }
        </div>
    )
}

export default TestimonialSlider